module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Communication/Reply-a2519a7b0972e65bf2834e932dcb05e3.svg";